import { WeatherYear } from '@scenario/models/weather-year.model';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';

export interface WeatherYearsState {
  weatherYears: WeatherYear[];
  isFetching: boolean;
  error?: string;
}

const initialState: WeatherYearsState = {
  weatherYears: [],
  isFetching: false,
};

export const weatherYearsSlice = createSlice({
  name: 'weatherYears',
  initialState,
  reducers: {
    retrieveWeatherYears: state => {
      state.isFetching = true;
    },
    retrieveWeatherYearsSuccess: (state, action: PayloadAction<WeatherYear[]>) => {
      state.weatherYears = action.payload;
      state.isFetching = false;
    },
    retrieveWeatherYearsFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
  },
});

export type WeatherYearsViewModel = {
  weatherYears: WeatherYear[];
  isFetching: boolean;
  error?: string;
};

export const selectWeatherYearOrdered = createSelector(
  (state: RootState) => state.weatherYears.weatherYears,
  (weatherYears: WeatherYear[]) => {
    const averageWeatherYear = weatherYears.filter((weatherYear) => weatherYear.name === 'AVERAGE');
    const ordererWeatherYears = weatherYears
      .filter(weatherYear => weatherYear.name !== 'AVERAGE')
      .sort((a, b) => a.name.localeCompare(b.name));
    return [...averageWeatherYear, ...ordererWeatherYears];
  },
);

export const selectWeatherYearsViewModel = createSelector(
  (state: RootState) => state,
  (state): WeatherYearsViewModel => ({
    weatherYears: selectWeatherYearOrdered(state),
    isFetching: state.weatherYears.isFetching,
    error: state.subtypes.error,
  }),
);
export const { retrieveWeatherYears, retrieveWeatherYearsSuccess, retrieveWeatherYearsFailure } =
  weatherYearsSlice.actions;

export default weatherYearsSlice.reducer;
